<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="620px"
    :title="$l('dialog_title_rejectHandling') ||'面料检验不合格处理'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <Main
      ref="main"
      :inspectionCode="inspectionCode"
      :isStop="isStop"
      @close="close"
    />

    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="save()">
        {{ $l('INDEX.btn_save') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    inspectionCode: { type: String, default: '' },
    isStop: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
  },
  methods: {
    save() {
      this.$refs.main.save()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
